<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品配件</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleAdd">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入属性标签关键字查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      配件商品SKU：<span>{{ item.cmsku }}</span>
                    </p>
                    <p>
                      配件商品名称：<span>{{ item.cmname }}</span>
                    </p>
                    <p>
                      每件配套数量：<span>{{ item.num }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      是否增加价格：<span>{{
                        item.isaddprice == 0 ? "否" : "是"
                      }}</span>
                    </p>
                    <p>
                      价格：<span>{{ item.price }}</span>
                    </p>
                    <p>
                      配件所属商品ID：<span>{{ item.cmid }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      所属企业名称：<span>{{
                        item.qyname ? item.qyname : ""
                      }}</span>
                    </p>
                    <p>
                      添加日期：<span>{{ item.addtime | formatDate }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn" @click="handleEdit(item.id)">编辑配件→</div>
            </div>
          </div>
        </template>

        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getShopAttachmentList } from "../../../api/shop";
export default {
  name: "cShopAttachment",
  data() {
    return {
      loading: false,
      searchTxt: "",
      params: {
        pageindex: 1,
        pagesize: 20,
        keyword: "",
        cmid: "",
      },
      listTotal: 0,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.cmid = id;
        this.getShopAttachmentList();
      } else {
        this.$router.back();
      }
    },

    getShopAttachmentList() {
      this.loading = true;
      getShopAttachmentList(this.params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    handleSearch() {
      this.getShopAttachmentList();
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getShopAttachmentList();
    },

    handleReturn() {
      history.back();
    },

    handleEdit(id) {
      let { cmId, cmSku } = this.$route.params;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cShopAttachmentSet",
        query: { id, cmId, cmSku },
      });
    },
    handleAdd() {
      let { cmId, cmSku } = this.$route.params;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cShopAttachmentSet",
        query: { cmId, cmSku },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .list_wrap {
    height: 57vh;
    .item_main_wrap {
      align-items: center;
      .icon-zanwutupian1 {
        font-size: 40px;
      }
      .pic_box {
        width: 80px;
        height: 80px;
      }
    }
  }
}
</style>